var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 298,
    height: 241.998,
    viewBox: "0 0 298 241.998",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28795",
    "data-name": "Group 28795",
    transform: "translate(-1450.681 -447)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25051",
    "data-name": "Group 25051",
    transform: "translate(426.783 376.962)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_62",
    "data-name": "Ellipse 62",
    cx: 57.611,
    cy: 57.611,
    r: 57.611,
    transform: "translate(1040.187 161.06)",
    fill: "#e5f1f7"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_63",
    "data-name": "Ellipse 63",
    cx: 21.297,
    cy: 21.297,
    r: 21.297,
    transform: "translate(1276.02 77.406)",
    fill: "#e5f1f7"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_124",
    "data-name": "Line 124",
    x1: 43,
    transform: "translate(1275.898 195.234)",
    fill: "none",
    stroke: "#e5f1f7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_125",
    "data-name": "Line 125",
    x1: 74,
    transform: "translate(1190.898 309.037)",
    fill: "none",
    stroke: "#e5f1f7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_126",
    "data-name": "Line 126",
    x1: 27,
    transform: "translate(1026.898 153.306)",
    fill: "none",
    stroke: "#e5f1f7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_127",
    "data-name": "Line 127",
    x1: 23,
    transform: "translate(1203.898 105.45)",
    fill: "none",
    stroke: "#e5f1f7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_128",
    "data-name": "Line 128",
    x1: 40.352,
    transform: "translate(1077.622 95.786)",
    fill: "none",
    stroke: "#3a78d6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_129",
    "data-name": "Line 129",
    x1: 6.725,
    transform: "translate(1131.425 95.786)",
    fill: "none",
    stroke: "#ff7800",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_130",
    "data-name": "Line 130",
    x1: 62.77,
    transform: "translate(1046.237 106.995)",
    fill: "none",
    stroke: "#3a78d6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_64",
    "data-name": "Ellipse 64",
    cx: 6.725,
    cy: 6.725,
    r: 6.725,
    transform: "translate(1173.574 86.819)",
    fill: "none",
    stroke: "#3a78d6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_65",
    "data-name": "Ellipse 65",
    cx: 5.604,
    cy: 5.604,
    r: 5.604,
    transform: "translate(1066.413 124.83)",
    fill: "none",
    stroke: "#ff7800",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45074",
    "data-name": "Path 45074",
    d: "M1281.724,224.084l-13.294,3.562a2.694,2.694,0,0,0-1.206,4.506l9.732,9.734a2.694,2.694,0,0,0,4.506-1.213l3.562-13.294a2.7,2.7,0,0,0-3.3-3.295Z",
    fill: "#e5f1f7"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_131",
    "data-name": "Line 131",
    x2: 11.209,
    transform: "translate(1057.446 200.924)",
    fill: "none",
    stroke: "#3a78d6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_132",
    "data-name": "Line 132",
    y1: 11,
    transform: "translate(1062.898 195.223)",
    fill: "none",
    stroke: "#3a78d6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_133",
    "data-name": "Line 133",
    x1: 147.958,
    transform: "translate(1100.04 292.651)",
    fill: "none",
    stroke: "#3a78d6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_134",
    "data-name": "Line 134",
    x1: 6.725,
    transform: "translate(1261.449 292.651)",
    fill: "none",
    stroke: "#ff7800",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_135",
    "data-name": "Line 135",
    x2: 134.507,
    transform: "translate(1156.085 281.442)",
    fill: "none",
    stroke: "#3a78d6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_136",
    "data-name": "Line 136",
    x2: 4.484,
    transform: "translate(1138.15 281.442)",
    fill: "none",
    stroke: "#ff7800",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_137",
    "data-name": "Line 137",
    x1: 42.594,
    transform: "translate(1265.932 167.355)",
    fill: "none",
    stroke: "#3a78d6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_138",
    "data-name": "Line 138",
    x1: 15.693,
    transform: "translate(1281.625 178.545)",
    fill: "none",
    stroke: "#ff7800",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_139",
    "data-name": "Line 139",
    x2: 8.224,
    transform: "translate(1139.539 113.349)",
    fill: "none",
    stroke: "#3a78d6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_140",
    "data-name": "Line 140",
    y1: 8.224,
    transform: "translate(1143.652 109.237)",
    fill: "none",
    stroke: "#3a78d6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45075",
    "data-name": "Path 45075",
    d: "M1096.981,72.166l2.237,8.346a1.69,1.69,0,0,0,2.829.758l6.109-6.109a1.69,1.69,0,0,0-.758-2.829l-8.346-2.235a1.691,1.691,0,0,0-2.071,2.069Z",
    fill: "#e5f1f7"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_66",
    "data-name": "Ellipse 66",
    cx: 5.604,
    cy: 5.604,
    r: 5.604,
    transform: "translate(1075.181 288.27)",
    fill: "#e5f1f7"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_141",
    "data-name": "Line 141",
    x2: 33.168,
    transform: "translate(1114.522 241.766)",
    fill: "none",
    stroke: "#ff7800",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_142",
    "data-name": "Line 142",
    x2: 30.686,
    transform: "translate(1133.87 232.063)",
    fill: "none",
    stroke: "#ff7800",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_143",
    "data-name": "Line 143",
    x2: 9.123,
    transform: "translate(1114.522 232.063)",
    fill: "none",
    stroke: "#ff7800",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_144",
    "data-name": "Line 144",
    x2: 50.034,
    transform: "translate(1114.522 222.36)",
    fill: "none",
    stroke: "#ff7800",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_25050",
    "data-name": "Group 25050",
    transform: "translate(-12.867 1.529)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45081",
    "data-name": "Path 45081",
    d: "M1152.407,186.046a10.11,10.11,0,1,1,10.11-10.11,10.11,10.11,0,0,1-10.11,10.11Z",
    fill: "none",
    stroke: "#3a78d6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_145",
    "data-name": "Line 145",
    y2: 3.279,
    transform: "translate(1129.536 205.08)",
    fill: "none",
    stroke: "#3a78d6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45082",
    "data-name": "Path 45082",
    d: "M1132.147,206.843v-.816c0-11.189,9.07-18.51,20.259-18.51h0c11.187,0,20.257,7.322,20.257,18.51v.816",
    transform: "translate(-12.867 1.529)",
    fill: "none",
    stroke: "#3a78d6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_146",
    "data-name": "Line 146",
    y1: 3.278,
    transform: "translate(1149.54 205.081)",
    fill: "none",
    stroke: "#3a78d6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45083",
    "data-name": "Path 45083",
    d: "M1293.8,93.544h-37.14a10.25,10.25,0,0,0-10.26,10.24v21.232a10.252,10.252,0,0,0,10.25,10.252h5.568v11.456a1.491,1.491,0,0,0,2.493,1.1l13.814-12.559H1293.8a10.251,10.251,0,0,0,10.252-10.25V103.793A10.249,10.249,0,0,0,1293.8,93.544Z",
    fill: "#e5f1f7"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_147",
    "data-name": "Line 147",
    x2: 11.635,
    transform: "translate(1260.437 118.345)",
    fill: "none",
    stroke: "#3a78d6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_148",
    "data-name": "Line 148",
    x2: 2.668,
    transform: "translate(1280.613 118.345)",
    fill: "none",
    stroke: "#3a78d6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_67",
    "data-name": "Ellipse 67",
    cx: 28,
    cy: 28,
    r: 28,
    transform: "translate(1033.898 222.037)",
    fill: "#fff",
    stroke: "#3a78d6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_149",
    "data-name": "Line 149",
    x2: 29.57,
    transform: "translate(1260.437 109.461)",
    fill: "none",
    stroke: "#3a78d6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45084",
    "data-name": "Path 45084",
    d: "M1050.517,248.017l9.569,9.569,13.974-13.974",
    fill: "none",
    stroke: "#ff7800",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28793",
    "data-name": "Group 28793",
    transform: "translate(9431.43 3522.143)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47402",
    "data-name": "Path 47402",
    d: "M1038.527,2578.01h49.289a5.413,5.413,0,0,0,5.406-5.407v-54.025a5.413,5.413,0,0,0-5.406-5.407h-2.545v-1.847a3.168,3.168,0,0,0-6.335,0v1.847h-6.286v-1.847a3.168,3.168,0,0,0-6.335,0v1.847h-6.286v-1.847a3.168,3.168,0,0,0-6.335,0v1.847h-6.286v-1.847a3.168,3.168,0,0,0-6.335,0v1.847h-2.545a5.413,5.413,0,0,0-5.407,5.407V2572.6A5.413,5.413,0,0,0,1038.527,2578.01Zm41.79-66.687a1.786,1.786,0,0,1,3.573,0v5.074a1.788,1.788,0,0,1-1.785,1.786h0a1.788,1.788,0,0,1-1.785-1.786Zm-12.622,0a1.787,1.787,0,0,1,3.573,0v5.074a1.788,1.788,0,0,1-1.786,1.786h0a1.788,1.788,0,0,1-1.785-1.786Zm-12.621,0a1.786,1.786,0,0,1,3.572,0v5.074a1.787,1.787,0,0,1-1.785,1.786h0a1.787,1.787,0,0,1-1.785-1.786Zm-12.621,0a1.786,1.786,0,0,1,3.573,0v5.074a1.788,1.788,0,0,1-1.786,1.786h0a1.788,1.788,0,0,1-1.785-1.786Zm-7.953,7.254a4.031,4.031,0,0,1,4.026-4.026h2.545v1.847a3.169,3.169,0,0,0,3.166,3.166h0a3.169,3.169,0,0,0,3.166-3.166v-1.847h6.286v1.847a3.169,3.169,0,0,0,3.166,3.166h0a3.169,3.169,0,0,0,3.166-3.166v-1.847h6.286v1.847a3.169,3.169,0,0,0,3.166,3.166h0a3.169,3.169,0,0,0,3.166-3.166v-1.847h6.286v1.847a3.169,3.169,0,0,0,3.166,3.166h0a3.17,3.17,0,0,0,3.166-3.166v-1.847h2.545a4.031,4.031,0,0,1,4.026,4.026v48.717a4.031,4.031,0,0,1-4.026,4.027h-49.289a4.032,4.032,0,0,1-4.026-4.027v-48.717Zm0,52.313a5.389,5.389,0,0,0,4.026,1.811h49.289a5.389,5.389,0,0,0,4.026-1.811v1.712a4.031,4.031,0,0,1-4.026,4.026h-49.289a4.031,4.031,0,0,1-4.026-4.026Z",
    transform: "translate(-8859.729 -5525.223)",
    fill: "#3a78d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47403",
    "data-name": "Path 47403",
    d: "M1044.767,2545.494h4.406a1.424,1.424,0,0,0,1.423-1.422v-4.405a1.425,1.425,0,0,0-1.423-1.423h-4.406a1.425,1.425,0,0,0-1.423,1.423v4.405A1.424,1.424,0,0,0,1044.767,2545.494Zm-.041-5.828a.041.041,0,0,1,.041-.042h4.406a.041.041,0,0,1,.041.042v4.405a.042.042,0,0,1-.041.042h-4.406a.042.042,0,0,1-.041-.042Z",
    transform: "translate(-8863.224 -5535.508)",
    fill: "#ff7800"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47404",
    "data-name": "Path 47404",
    d: "M1064.72,2545.494h4.405a1.424,1.424,0,0,0,1.423-1.422v-4.405a1.425,1.425,0,0,0-1.423-1.423h-4.405a1.424,1.424,0,0,0-1.422,1.423v4.405A1.423,1.423,0,0,0,1064.72,2545.494Zm-.042-5.828a.041.041,0,0,1,.042-.042h4.405a.041.041,0,0,1,.042.042v4.405a.042.042,0,0,1-.042.042h-4.405a.042.042,0,0,1-.042-.042Z",
    transform: "translate(-8870.046 -5535.508)",
    fill: "#e5f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47405",
    "data-name": "Path 47405",
    d: "M1084.673,2545.494h4.405a1.424,1.424,0,0,0,1.423-1.422v-4.405a1.425,1.425,0,0,0-1.423-1.423h-4.405a1.424,1.424,0,0,0-1.422,1.423v4.405A1.423,1.423,0,0,0,1084.673,2545.494Zm-.041-5.828a.041.041,0,0,1,.041-.042h4.405a.041.041,0,0,1,.042.042v4.405a.042.042,0,0,1-.042.042h-4.405a.042.042,0,0,1-.041-.042Z",
    transform: "translate(-8876.867 -5535.508)",
    fill: "#e5f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47406",
    "data-name": "Path 47406",
    d: "M1104.626,2545.494h4.405a1.424,1.424,0,0,0,1.423-1.422v-4.405a1.425,1.425,0,0,0-1.423-1.423h-4.405a1.424,1.424,0,0,0-1.422,1.423v4.405A1.423,1.423,0,0,0,1104.626,2545.494Zm-.042-5.828a.041.041,0,0,1,.042-.042h4.405a.041.041,0,0,1,.042.042v4.405a.042.042,0,0,1-.042.042h-4.405a.042.042,0,0,1-.042-.042Z",
    transform: "translate(-8883.688 -5535.508)",
    fill: "#e5f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47407",
    "data-name": "Path 47407",
    d: "M1044.767,2565.447h4.406a1.424,1.424,0,0,0,1.423-1.422v-4.406a1.425,1.425,0,0,0-1.423-1.423h-4.406a1.425,1.425,0,0,0-1.423,1.423v4.406A1.424,1.424,0,0,0,1044.767,2565.447Zm-.041-5.828a.042.042,0,0,1,.041-.042h4.406a.042.042,0,0,1,.041.042v4.406a.041.041,0,0,1-.041.042h-4.406a.041.041,0,0,1-.041-.042Z",
    transform: "translate(-8863.224 -5542.33)",
    fill: "#e5f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47408",
    "data-name": "Path 47408",
    d: "M1064.72,2565.447h4.405a1.424,1.424,0,0,0,1.423-1.422v-4.406a1.425,1.425,0,0,0-1.423-1.423h-4.405a1.424,1.424,0,0,0-1.422,1.423v4.406A1.423,1.423,0,0,0,1064.72,2565.447Zm-.042-5.828a.042.042,0,0,1,.042-.042h4.405a.042.042,0,0,1,.042.042v4.406a.041.041,0,0,1-.042.042h-4.405a.041.041,0,0,1-.042-.042Z",
    transform: "translate(-8870.046 -5542.33)",
    fill: "#e5f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47409",
    "data-name": "Path 47409",
    d: "M1104.626,2565.447h4.405a1.424,1.424,0,0,0,1.423-1.422v-4.406a1.425,1.425,0,0,0-1.423-1.423h-4.405a1.424,1.424,0,0,0-1.422,1.423v4.406A1.423,1.423,0,0,0,1104.626,2565.447Zm-.042-5.828a.042.042,0,0,1,.042-.042h4.405a.042.042,0,0,1,.042.042v4.406a.041.041,0,0,1-.042.042h-4.405a.041.041,0,0,1-.042-.042Z",
    transform: "translate(-8883.688 -5542.33)",
    fill: "#e5f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47410",
    "data-name": "Path 47410",
    d: "M1044.767,2585.4h4.406a1.425,1.425,0,0,0,1.423-1.423v-4.406a1.425,1.425,0,0,0-1.423-1.422h-4.406a1.425,1.425,0,0,0-1.423,1.422v4.406A1.425,1.425,0,0,0,1044.767,2585.4Zm-.041-5.829a.041.041,0,0,1,.041-.041h4.406a.041.041,0,0,1,.041.041v4.406a.041.041,0,0,1-.041.042h-4.406a.041.041,0,0,1-.041-.042Z",
    transform: "translate(-8863.224 -5549.151)",
    fill: "#e5f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47411",
    "data-name": "Path 47411",
    d: "M1064.72,2585.4h4.405a1.425,1.425,0,0,0,1.423-1.423v-4.406a1.425,1.425,0,0,0-1.423-1.422h-4.405a1.424,1.424,0,0,0-1.422,1.422v4.406A1.424,1.424,0,0,0,1064.72,2585.4Zm-.042-5.829a.041.041,0,0,1,.042-.041h4.405a.041.041,0,0,1,.042.041v4.406a.041.041,0,0,1-.042.042h-4.405a.041.041,0,0,1-.042-.042Z",
    transform: "translate(-8870.046 -5549.151)",
    fill: "#e5f1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47412",
    "data-name": "Path 47412",
    d: "M1083.351,2565.948h5.969a1.684,1.684,0,0,0,1.682-1.682V2558.3a1.684,1.684,0,0,0-1.682-1.682h-5.969a1.685,1.685,0,0,0-1.683,1.682v5.969A1.685,1.685,0,0,0,1083.351,2565.948Zm-.3-7.651a.3.3,0,0,1,.3-.3h5.969a.3.3,0,0,1,.3.3v5.969a.3.3,0,0,1-.3.3h-5.969a.3.3,0,0,1-.3-.3Z",
    transform: "translate(-8876.326 -5541.789)",
    fill: "#e5f1f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28794",
    "data-name": "Group 28794",
    transform: "translate(9675.818 3593)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47413",
    "data-name": "Path 47413",
    d: "M340.6,2473.979H360.5a4.306,4.306,0,0,0,2.984-1.2l5.264,1.146a4.355,4.355,0,0,0,.928.1,4.329,4.329,0,0,0,4.217-3.406l8.635-39.671a4.33,4.33,0,0,0-3.306-5.146l-19.438-4.231a4.316,4.316,0,0,0-5.106,3.16H340.6a4.33,4.33,0,0,0-4.325,4.325v40.6A4.33,4.33,0,0,0,340.6,2473.979Zm24.219-9.134,4.843,1.054a1.469,1.469,0,1,1-.625,2.871l-4.218-.918Zm0-7.305a1.48,1.48,0,0,1,.472.016l5.907,1.285a1.47,1.47,0,0,1-.625,2.872l-5.754-1.253Zm0-21.766a1.423,1.423,0,0,1,0,1.443Zm-.176-7.929.749.163a1.467,1.467,0,0,1-.574,2.877v-1.831A4.3,4.3,0,0,0,364.645,2427.844Zm-7.544-4.79a3.235,3.235,0,0,1,2.453-.443l19.439,4.231a3.257,3.257,0,0,1,2.49,3.875l-8.635,39.67a3.257,3.257,0,0,1-3.875,2.49l-4.753-1.035a4.29,4.29,0,0,0,.6-2.19v-.709l3.991.868a2.537,2.537,0,1,0,1.079-4.958l-5.07-1.1v-2.2l5.527,1.2a2.537,2.537,0,1,0,1.079-4.958l-5.907-1.286a2.54,2.54,0,0,0-.7-.05v-2.646a2.515,2.515,0,0,0,1.156.6l5.907,1.286a2.537,2.537,0,1,0,1.08-4.958l-5.907-1.286a2.537,2.537,0,0,0-2.236.6v-11.359a2.53,2.53,0,0,0,0-4.378v-2.346c.088.009.175.014.261.014a2.537,2.537,0,0,0,.539-5.017l-1.444-.314-.023.108a4.321,4.321,0,0,0-3.658-2.029h-4.71A3.228,3.228,0,0,1,357.1,2423.055Zm7.98,28.565a1.468,1.468,0,0,1,1.748-1.123l5.907,1.286a1.469,1.469,0,1,1-.624,2.871l-5.907-1.286A1.472,1.472,0,0,1,365.081,2451.62Zm-27.736-22.566a3.261,3.261,0,0,1,3.257-3.257H360.5a3.261,3.261,0,0,1,3.257,3.257v40.6a3.261,3.261,0,0,1-3.257,3.257H340.6a3.261,3.261,0,0,1-3.257-3.257Z",
    transform: "translate(-8400.396 -5421.767)",
    fill: "#3a78d6",
    opacity: 0.76
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47414",
    "data-name": "Path 47414",
    d: "M345.26,2444.642h6.045a2.537,2.537,0,1,0,0-5.075H345.26a2.537,2.537,0,0,0,0,5.075Zm0-4.007h6.045a1.469,1.469,0,1,1,0,2.938H345.26a1.469,1.469,0,1,1,0-2.938Z",
    transform: "translate(-8404.578 -5432.347)",
    fill: "#3a78d6",
    opacity: 0.76
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47415",
    "data-name": "Path 47415",
    d: "M375.625,2444.642h6.045a2.537,2.537,0,0,0,0-5.075h-6.045a2.537,2.537,0,0,0,0,5.075Zm0-4.007h6.045a1.469,1.469,0,1,1,0,2.938h-6.045a1.469,1.469,0,0,1,0-2.938Z",
    transform: "translate(-8422.712 -5432.347)",
    fill: "#3a78d6",
    opacity: 0.76
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47416",
    "data-name": "Path 47416",
    d: "M345.26,2462.574h6.045a2.537,2.537,0,1,0,0-5.074H345.26a2.537,2.537,0,1,0,0,5.074Zm0-4.007h6.045a1.469,1.469,0,1,1,0,2.939H345.26a1.469,1.469,0,1,1,0-2.939Z",
    transform: "translate(-8404.578 -5443.056)",
    fill: "#3a78d6",
    opacity: 0.76
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47417",
    "data-name": "Path 47417",
    d: "M375.625,2462.574h6.045a2.537,2.537,0,1,0,0-5.074h-6.045a2.537,2.537,0,0,0,0,5.074Zm0-4.007h6.045a1.469,1.469,0,1,1,0,2.939h-6.045a1.469,1.469,0,0,1,0-2.939Z",
    transform: "translate(-8422.712 -5443.056)",
    fill: "#3a78d6",
    opacity: 0.76
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47418",
    "data-name": "Path 47418",
    d: "M345.26,2480.506h6.045a2.537,2.537,0,1,0,0-5.074H345.26a2.537,2.537,0,1,0,0,5.074Zm0-4.006h6.045a1.469,1.469,0,1,1,0,2.938H345.26a1.469,1.469,0,1,1,0-2.938Z",
    transform: "translate(-8404.578 -5453.765)",
    fill: "#3a78d6",
    opacity: 0.76
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47419",
    "data-name": "Path 47419",
    d: "M375.625,2480.506h6.045a2.537,2.537,0,1,0,0-5.074h-6.045a2.537,2.537,0,0,0,0,5.074Zm0-4.006h6.045a1.469,1.469,0,1,1,0,2.938h-6.045a1.469,1.469,0,0,1,0-2.938Z",
    transform: "translate(-8422.712 -5453.765)",
    fill: "#3a78d6",
    opacity: 0.76
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47420",
    "data-name": "Path 47420",
    d: "M345.26,2498.439h6.045a2.537,2.537,0,1,0,0-5.074H345.26a2.537,2.537,0,1,0,0,5.074Zm0-4.007h6.045a1.469,1.469,0,1,1,0,2.938H345.26a1.469,1.469,0,1,1,0-2.938Z",
    transform: "translate(-8404.578 -5464.475)",
    fill: "#3a78d6",
    opacity: 0.76
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47421",
    "data-name": "Path 47421",
    d: "M375.625,2498.439h6.045a2.537,2.537,0,1,0,0-5.074h-6.045a2.537,2.537,0,0,0,0,5.074Zm0-4.007h6.045a1.469,1.469,0,1,1,0,2.938h-6.045a1.469,1.469,0,0,1,0-2.938Z",
    transform: "translate(-8422.712 -5464.475)",
    fill: "#3a78d6",
    opacity: 0.76
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47422",
    "data-name": "Path 47422",
    d: "M345.26,2516.372h6.045a2.537,2.537,0,1,0,0-5.074H345.26a2.537,2.537,0,1,0,0,5.074Zm0-4.007h6.045a1.469,1.469,0,1,1,0,2.939H345.26a1.469,1.469,0,1,1,0-2.939Z",
    transform: "translate(-8404.578 -5475.184)",
    fill: "#3a78d6",
    opacity: 0.76
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47423",
    "data-name": "Path 47423",
    d: "M375.625,2516.372h6.045a2.537,2.537,0,1,0,0-5.074h-6.045a2.537,2.537,0,0,0,0,5.074Zm0-4.007h6.045a1.469,1.469,0,1,1,0,2.939h-6.045a1.469,1.469,0,0,1,0-2.939Z",
    transform: "translate(-8422.712 -5475.184)",
    fill: "#3a78d6",
    opacity: 0.76
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47424",
    "data-name": "Path 47424",
    d: "M345.26,2534.3h6.045a2.537,2.537,0,1,0,0-5.074H345.26a2.537,2.537,0,1,0,0,5.074Zm0-4.007h6.045a1.469,1.469,0,1,1,0,2.939H345.26a1.469,1.469,0,0,1,0-2.939Z",
    transform: "translate(-8404.578 -5485.893)",
    fill: "#3a78d6",
    opacity: 0.76
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47425",
    "data-name": "Path 47425",
    d: "M375.625,2534.3h6.045a2.537,2.537,0,1,0,0-5.074h-6.045a2.537,2.537,0,0,0,0,5.074Zm0-4.007h6.045a1.469,1.469,0,0,1,0,2.939h-6.045a1.469,1.469,0,0,1,0-2.939Z",
    transform: "translate(-8422.712 -5485.893)",
    fill: "#3a78d6",
    opacity: 0.76
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47426",
    "data-name": "Path 47426",
    d: "M418.489,2443.249l5.907,1.286a2.557,2.557,0,0,0,.545.059,2.538,2.538,0,0,0,.535-5.017l-5.907-1.286a2.537,2.537,0,0,0-1.079,4.958Zm-.9-2.792a1.469,1.469,0,0,1,1.748-1.123l5.907,1.285a1.469,1.469,0,1,1-.625,2.872l-5.907-1.286a1.469,1.469,0,0,1-1.123-1.748Z",
    transform: "translate(-8448.632 -5431.549)",
    fill: "#3a78d6",
    opacity: 0.76
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47427",
    "data-name": "Path 47427",
    d: "M414.676,2460.772l5.907,1.286a2.537,2.537,0,0,0,1.079-4.958l-5.907-1.286a2.537,2.537,0,0,0-1.08,4.958Zm-.9-2.792a1.473,1.473,0,0,1,1.436-1.157,1.488,1.488,0,0,1,.313.034l5.907,1.286a1.469,1.469,0,1,1-.625,2.871l-5.907-1.286A1.471,1.471,0,0,1,413.78,2457.98Z",
    transform: "translate(-8446.355 -5442.015)",
    fill: "#3a78d6",
    opacity: 0.76
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47428",
    "data-name": "Path 47428",
    d: "M417.847,2474.62l-5.907-1.286a2.537,2.537,0,1,0-1.08,4.958l5.907,1.286a2.554,2.554,0,0,0,.545.059,2.538,2.538,0,0,0,.534-5.017Zm.9,2.792a1.468,1.468,0,0,1-1.748,1.123l-5.907-1.286a1.469,1.469,0,1,1,.625-2.871l5.907,1.285a1.47,1.47,0,0,1,1.123,1.749Z",
    transform: "translate(-8444.076 -5452.478)",
    fill: "#3a78d6",
    opacity: 0.76
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoUser);
export default __webpack_public_path__ + "static/media/NoUser.6d97e199.svg";
export { ForwardRef as ReactComponent };